// The Walkout — all onboarding copy in one place. Eric iterates on voice here.
// Guardrails: no prices/values, no buy/sell/trade, no "official", plain set names.

export const copy = {
  skip: 'Skip for now',
  back: 'Back',

  r1: {
    h1: 'EVERY COLLECTION HAS A WALKOUT.',
    body: 'Yours starts now. 60 seconds to set your corner.',
    primary: 'Make the walk',
  },

  r2: {
    h1: 'TALE OF THE TAPE',
    label: 'What do we call you?',
    placeholder: 'Your collector name',
    helper: '3–20 characters',
    primary: 'Next',
  },

  r3: {
    h1: 'PICK YOUR DIVISION',
    sub: 'How do you collect? Tap any that fit — all, some, or none.',
    primary: 'Next',
  },

  r4: {
    h1: 'PICK YOUR CORNER',
    sub: 'Who are you collecting?',
    suggested: 'Top fighters',
    searchPlaceholder: 'Search fighters',
    helper: 'Choose 1–5',
    primary: 'Next',
    empty: 'No fighters match that.',
  },

  r5: {
    h1: 'START YOUR CHASE',
    sub: 'Pick a set to chase.',
    subSetBuilder: 'A few sets to start — or search for yours.',
    subOptional: 'Optional — pin a set to chase, or skip.',
    suggested: 'Suggested sets',
    searchPlaceholder: 'Search all sets',
    changeSet: 'Change set',
    skipChase: 'Skip for now',
    ownPrompt: 'Tap the ones you own.',
    zero: 'The chase starts at zero.',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    primary: 'Save my chase',
    loadingSets: 'Loading sets…',
    loadingChecklist: 'Loading checklist…',
    retry: 'Retry',
    empty: 'No sets match that.',
  },

  finish: {
    h1: "YOU'RE IN",
  },

  banner: {
    text: 'Finish your setup — 60 seconds',
    cta: 'Finish',
    dismiss: 'Dismiss',
  },

  // R3 archetypes — enum + one-liner. Glyphs are inline SVG in the component.
  archetypes: [
    { id: 'set_builder', name: 'Set Builder', line: 'Complete base sets, front to back.' },
    { id: 'rainbow_chaser', name: 'Rainbow Chaser', line: 'Every parallel of the one card.' },
    { id: 'fighter_pc', name: 'Fighter Collector', line: 'Your fighters. Every card.' },
    { id: 'rookie_hunter', name: 'Rookie Hunter', line: 'First cards. Future champs.' },
    { id: 'hits', name: 'Hits Collector', line: 'Autos and memorabilia only.' },
  ],

  // R4 fallback — curated well-known fighters. TODO(eric): replace with live query
  // when a fighter is not found in the environment. IDs are placeholders; the
  // component prefers live fighter docs and only shows these when the query is empty.
  fallbackFighters: [
    'Jon Jones', 'Israel Adesanya', 'Conor McGregor', 'Khabib Nurmagomedov',
    'Georges St-Pierre', 'Anderson Silva', 'Amanda Nunes', 'Valentina Shevchenko',
    'Kamaru Usman', 'Alexander Volkanovski', 'Charles Oliveira', 'Max Holloway',
    'Dustin Poirier', 'Islam Makhachev', 'Ronda Rousey', 'Daniel Cormier',
    'Stipe Miocic', 'Francis Ngannou', 'Sean O’Malley', 'Zhang Weili',
  ],
};

export default copy;
